import { useSyncExternalStore } from 'react';

import * as translator from './translator';

import i18next from 'i18next';

let version = 0;
const subscribe = (callback: () => void) => {
  const onChange = () => {
    version++;
    callback();
  };
  i18next.on('languageChanged', onChange);
  return () => i18next.off('languageChanged', onChange);
};

export default () => {
  useSyncExternalStore(subscribe, () => version);
  return {
    language: translator.getLanguage(),
    languages: translator.languages,
    t: translator.t,
    tr: translator.tr,
    tns: translator.tns,
    translate: translator.t,
    te: translator.te,
    exists: translator.exists,
    changeLanguage: translator.changeLanguage,
    ready: true,
  };
};
